import i18n from '../i18n';

// Маппинг бэкенд-кодов на ключи локалей. Используется когда бэк отдаёт
// чистый result-код без result_text (страховка для disposable-keys).
const RESULT_TEXT_KEYS = {
    '1856': 'views.Login.41',
    '1857': 'views.Login.42',
};

const lib = {
    req(req, store, router) {
        if (typeof req.data == 'undefined') {
            req.data = {data:{}};
        }
        if (store.state.pay_pass) {
            req.data.data.cabinet_pay_password = store.state.pay_pass;
            store.commit('PAY_PASS', false);
        }
        req.data.device_fingerprint = store.state.fingerprint;
        req.data.lang = localStorage.getItem("lang");
        if (req.data.no_loader) {
            delete req.data.no_loader;
        } else {
            store.commit('LOADER', true);
        }
        req.headers['Auth-Page'] = 'true';
    },


    res(res, store, router) {
        store.commit('LOADER', false);
        if (res.data && res.data.body && RESULT_TEXT_KEYS[res.data.body.result] && !res.data.body.result_text) {
            res.data.body.result_text = i18n.global.t(RESULT_TEXT_KEYS[res.data.body.result]);
        }
        if (res.config.method == 'get') {
            return
        }
        if (res.data.isLogged === true) {
            store.commit('IS_LOGGED', res.data.isLogged);
            // if (!store.state.domains && res.data.body.domains) {
            //     store.commit('DOMAINS', res.data.body.domains);
            // }
        } else if (res.data.isLogged === false) {
            // if (!store.state.domains && res.data.body.domains) {
            //     store.commit('DOMAINS', res.data.body.domains);
            // }
            store.commit('IS_LOGGED', res.data.isLogged);
            // store.commit('USER_DATA', {});
            if (!res.data.body.alter) {
                store.commit('MODAL', {
                    action: false,
                    type: false,
                    content: false,});
            }
            store.commit('DARK_WRAPPER', false);
        } else {
            router.push('/unexpected');
        }
        if (res.data.modal) {
            if (res.data.modal == 'repeat') {
                const regExp = /\d+/;
                let attempts = false;
                let parts;
                const advanced = res.data.body.advanced || {};
                if(advanced.confirm_text && res.data.body.result == '856') {
                    parts = advanced.confirm_text.split('.')
                    if(parts[1]) {
                        attempts = parts[1].match(regExp)
                    }
                }
                if (advanced.notify_text) {
                    attempts = advanced.notify_text
                }
                if(attempts !== false && !attempts && parts && parts[1]) {
                    store.commit('WARNING', {
                        warningType: 'error',
                        warningText: parts[1]
                    })
                    return
                }
                res.data.body.repeat_url = res.config.url;
            }
            if (this.inArray(res.config.url, ['SearchMember', 'GetComiss', 'checkUnique']) && res.data.modal != 'questionnaire') {
                if (res.data.risk_form) {
                    store.commit('MODAL_ACTION', true);
                    store.commit('MODAL_TYPE', 'questionnaire');
                    store.commit('MODAL_CONTENT', res.data.risk_form);
                }
                return
            }
            store.commit('MODAL_ACTION', true);
            store.commit('MODAL_TYPE', res.data.modal);
            store.commit('MODAL_CONTENT', res.data.body);
        }
        if (res.data.error) {
            store.commit('ERROR', res.data.error);
            store.commit('WARNING', {
                warningType: 'error',
                warningText: res.data.body.result_text
            })
        }
        if (res.data.body.updating) {
            if (res.data.body.updating.keyts) {
                store.commit('USER_DATA_KEYTS', res.data.body.updating.keyts);
                store.commit('GLOBAL_KEY_KEYT');
            }
            if (res.data.body.updating.templates) {
                store.commit('USER_DATA_TEMPLATES', res.data.body.updating.templates);
            }
            if (res.data.body.updating.user_info) {
                let inf = res.data.body.updating.user_info; 
                store.commit('USER_DATA_INFO', inf);
                if (inf.avatar) {
                    let av = "";
                    if (inf.avatar.value.length > 0) {
                        av = inf.avatar.value[0].body;  
                    }
                    store.commit('USER_DATA_AVATAR', av);
                }
            }
        }
        if (res.data.risk_form) {
            store.commit('MODAL_ACTION', true);
            store.commit('MODAL_TYPE', 'questionnaire');
            store.commit('MODAL_CONTENT', res.data.risk_form);
        }
    },

    err(err, store, router) {
        store.commit('LOADER', false);
        if (err.config.method == 'get') {
            return
        }
        // Вместо нативного alert — тост (мягче, в стиле редизайна).
        const text = err.response
            ? `${err.response.status} · ${err.response.statusText}`
            : 'Network error';
        store.commit('WARNING', { warningType: 'error', warningText: text });
    },

    checkRegExp(str, reg) {
        let regexp = new RegExp(reg);
        return regexp.test(str);
    },

    alertE(store, body) {
        store.commit('MODAL_ACTION', true);
        store.commit('MODAL_TYPE', 'answer');
        store.commit('MODAL_CONTENT', body);
    },

    isInt(x) {
        var y = parseInt(x);
        if (isNaN(y))
            return false;
        return x == y && x.toString() == y.toString();
    },

    HardcodeCurrPrecision(curr, amount) {

        if (this.inArray(curr, ['RUR', 'USD', 'EUR', 'VLS']) != -1)
            return 2;
        else if (this.inArray(curr, ['BTC']) != -1)
            return 8;
        else if (this.inArray(curr, ['ETH']) != -1)
            return 10;
        else
            return amount.split('.').pop().length || 2;
    },

    inArray(curr, arr) {
        if (arr.indexOf(curr) != -1) {  
            return true;
        } else {
            return false;
        }
    },

    RandomDigit(len) {
        var r;
        var digit = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9");
    
        let pasw = "";
    
        for (var i = 0; i < len; i++) {
            r = Math.floor(Math.random() * 9);
            pasw += digit[r];
        }
        return pasw;
    },

    cRound(num) {
        return Math.floor(num * 100) / 100;
    }

}

export default lib;